// Shown on the FAQs page and the homepage (the first six), and published as FAQPage
// structured data. Keep answers to what the app ships (backend/docs/*.md).
export const FAQ_ITEMS = [
    {
        question: "What is Accruewise?",
        answer:
            "Accruewise is a money app for India. It tracks your spends from bank alerts, splits bills with friends, pays bills and recharges, sends money to bank accounts, UPI IDs and other Accruewise Wallets, helps you plan savings goals, and gives you a prepaid RuPay card, all in one app, in English or Hindi.",
    },
    {
        question: "How does automatic spend tracking work?",
        answer:
            "On Android, if you allow SMS access, the app looks for the transaction alerts your bank, UPI app and card send you. Only messages from bank sender IDs that mention an amount are sent to be sorted, never messages from personal numbers. Autopay and bill reminders, failed transactions and duplicate alerts are skipped, and you can edit or delete any entry. You can switch SMS reading off at any time from the tracker's menu.",
    },
    {
        question: "How do Splits work?",
        answer:
            "Open Split bills, add an expense or tap Split this on a spend, bill or voucher, and choose a group or friends. Split equally, by exact amounts, percentages or shares; the shares always add up to the total. Everyone sees who owes whom, and you settle up from your Accruewise Wallet, with any UPI app, or by marking a cash payment as done. Friends who aren't on Accruewise can be added by phone number: you share the invite link, and their balances are waiting when they sign up.",
    },
    {
        question: "Is Accruewise available on iPhone?",
        answer:
            "Accruewise is live on Android through Google Play. The iPhone app is coming to the App Store; join the waitlist on this site and we'll message you on launch day.",
    },
    {
        question: "Which bills and recharges can I pay?",
        answer:
            "Mobile and DTH recharges, and bills from billers on Bharat BillPay (BBPS) such as electricity, broadband, gas, water, postpaid, FASTag, loan EMIs and insurance. You pay from your Accruewise Wallet, see the full amount before you approve, and get a reminder before a bill is due or a plan runs out.",
    },
    {
        question: "How do I open the wallet, and what are the limits?",
        answer:
            "A quick KYC opens your Accruewise Wallet: verify Aadhaar through DigiLocker and confirm a few details. When you need more room, upgrade your limit up to ₹2L with your PAN and a short video call; the upgrade also adds UPI. The wallet holds up to ₹2,00,000.",
    },
    {
        question: "Can I track spends on iPhone?",
        answer:
            "Yes. iPhone doesn't let apps read SMS, so copy a bank alert and tap Paste bank SMS on the Add screen: the amount, payee, category and date fill in for you. You can also add entries by hand: type the amount and tap Save.",
    },
    {
        question: "How do I add money to Accruewise?",
        answer:
            "Open your Accruewise Wallet and tap Add money. You can pay in by bank transfer (IMPS or NEFT) to the wallet's own account number, or with any UPI app. If your wallet doesn't show an account number or UPI ID yet, the Full KYC upgrade (your PAN and a short video call) unlocks them.",
    },
    {
        question: "Can I send money to my bank or to a friend?",
        answer:
            "Yes. Send money to a bank account you've saved by IMPS, or pay a UPI ID; transfers to a bank account are confirmed with an OTP. To send to someone's Accruewise Wallet, tap Send on your wallet and enter their phone number: you see their name and the last four digits before you confirm with your MPIN or fingerprint.",
    },
    {
        question: "What is the Accruewise card?",
        answer:
            "A prepaid RuPay card on your Accruewise Wallet, for online and in-store payments. You get a virtual card when your wallet opens, and you can order a physical card to a saved address. In Card settings you can block the card, set its PIN, and choose where it works: online, in store, contactless, ATM and international.",
    },
    {
        question: "How do savings goals work?",
        answer:
            "Pick what you're saving for, the amount and the date, and Accruewise shows what to put aside each week. Each goal also has “Reach it faster”, with suggestions built from your own spends and live offers, such as a category to trim or a gift-voucher discount.",
    },
    {
        question: "Are round-ups and auto-save available?",
        answer: "Not yet. Round-ups and auto-save are coming soon.",
    },
    {
        question: "What is NCMC top-up?",
        answer:
            "If you have a National Common Mobility Card for the metro or buses, you can add money to it from your Accruewise Wallet before you reach the gate.",
    },
    {
        question: "Can I control the notifications I get?",
        answer:
            "Yes. Each kind of notification (summaries, goals, rewards and reminders) has its own switch, and friendly reminders are limited to two a day. Payment and security alerts always come through. The 9 PM spend summary can be switched off under Summaries.",
    },
    {
        question: "Is my money safe with Accruewise?",
        answer:
            "Your Accruewise Wallet is powered by ToPay, and payments run over encrypted connections. The app is locked by your 6-digit MPIN or fingerprint, every payment asks for it again, and transfers to a bank account are confirmed with an OTP.",
    },
    {
        question: "Can I use Accruewise in Hindi?",
        answer: "Yes. The whole app is available in English and Hindi, and you can switch any time from your profile. The Assistant understands both.",
    },
    {
        question: "Does Accruewise share my personal data?",
        answer:
            "Accruewise does not share your personal or financial data with third parties without your consent, except where required by law or described in the privacy policy. In Splits, friends never see your phone number.",
    },
    {
        question: "How do I delete my account?",
        answer:
            "In the app, go to Profile → About Accruewise → Delete account and confirm with your MPIN or fingerprint. We settle your wallet and card and then delete the account. You can also write to care@accruewise.in.",
    },
    {
        question: "Is Accruewise available in India only?",
        answer: "Yes. Accruewise is currently available in India only.",
    },
];
